import React from "react";
import Banner from "../home components/Banner";

/**
 * Reusable banner wrapper.
 *
 * Use this component on any page where you want the existing
 * home Banner design without tying that page directly to the
 * original Banner file.
 *
 * Example:
 * import ReusableBanner from "../components/ReusableBanner";
 *
 * <ReusableBanner />
 */
export default function ReusableBanner(props) {
  return <Banner {...props} />;
}